import { Space } from "antd";
import { useIntl } from "react-intl";
import { useLockUnlockFixture } from "../../hooks";
import type { FixtureTransformed } from "../../types";

interface ILockUnlockFixtureActionProperties {
  fixture: FixtureTransformed;
  onLockUnlockClicked: (fixtureId: string) => void;
}

export const LockUnlockFixtureAction = (properties: ILockUnlockFixtureActionProperties) => {
  const { formatMessage } = useIntl();
  const { mutateAsync: lockUnlockFixture } = useLockUnlockFixture();

  const onClickHandler = async () =>
    await lockUnlockFixture({
      fixtureId: properties.fixture.fixtureId,
      locked: properties.fixture.locked,
      onSuccess: () => properties.onLockUnlockClicked(properties.fixture.fixtureId),
    });

  const iconClassName = properties.fixture.locked ? "fa-lock-open" : "fa-lock";

  return (
    <Space style={{ columnGap: "5px" }} onClick={onClickHandler}>
      <i className={`fas mr-2 ${iconClassName}`}></i>
      {formatMessage({
        id: properties.fixture.locked ? "match.unlock" : "match.lock",
      })}
    </Space>
  );
};
